import React, { useState } from "react";
import { Mail, ArrowRight, Check } from "lucide-react";
import { toast } from "sonner";
import MarketingLayout from "../../components/marketing/MarketingLayout";
import Seo from "../../components/Seo";

export default function Contact() {
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", organization: "", need: "Software Product", message: "" });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email) { toast.error("Please add your name and email."); return; }
    setSent(true);
    toast.success("Thanks! We'll be in touch shortly.");
  };

  return (
    <MarketingLayout>
      <Seo title="Contact — Let's Build Your Solution" description="Tell us about your problem and we'll design the right solution." />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-12 py-20 grid lg:grid-cols-2 gap-14 items-start">
        <div>
          <p className="eyebrow text-alto-red mb-4">Contact</p>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold leading-tight">LET'S BUILD<br />YOUR SOLUTION.</h1>
          <p className="text-neutral-300 mt-6 text-sm sm:text-base leading-relaxed max-w-md">Tell us about your organization and the problem you're trying to solve. We'll recommend the right product, service or custom build.</p>
          <div className="mt-8 flex items-center gap-3 text-neutral-300"><Mail className="text-alto-red" size={18} /><span className="text-sm">hello@alltomaidit.com</span></div>
        </div>

        <div className="card-hairline rounded-2xl p-8 bg-alto-charcoal">
          {sent ? (
            <div className="text-center py-10" data-testid="contact-success">
              <div className="w-14 h-14 rounded-full bg-alto-red/15 flex items-center justify-center mx-auto mb-5"><Check className="text-alto-red" size={28} /></div>
              <h2 className="font-display text-2xl font-bold">Message received.</h2>
              <p className="text-neutral-400 text-sm mt-3">We'll reach out within one business day.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
              <Field label="Name" value={form.name} onChange={set("name")} testid="contact-name" />
              <Field label="Email" type="email" value={form.email} onChange={set("email")} testid="contact-email" />
              <Field label="Organization" value={form.organization} onChange={set("organization")} testid="contact-org" />
              <div>
                <label className="block text-xs font-semibold text-neutral-400 mb-1.5">What do you need?</label>
                <select value={form.need} onChange={set("need")} data-testid="contact-need" className="w-full bg-black border border-white/15 rounded-md px-4 py-3 text-sm text-white focus:border-alto-red outline-none">
                  {["Software Product", "AI & Automation", "Web Development", "Digital Marketing", "Branding", "IT Solutions", "A combination / custom solution"].map((o) => <option key={o}>{o}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-xs font-semibold text-neutral-400 mb-1.5">Tell us about your problem</label>
                <textarea value={form.message} onChange={set("message")} rows={4} data-testid="contact-message" className="w-full bg-black border border-white/15 rounded-md px-4 py-3 text-sm text-white focus:border-alto-red outline-none resize-none" />
              </div>
              <button type="submit" data-testid="contact-submit" className="btn-red w-full font-bold px-6 py-3.5 rounded-md inline-flex items-center justify-center gap-2 text-sm">SEND MESSAGE <ArrowRight size={16} /></button>
            </form>
          )}
        </div>
      </div>
    </MarketingLayout>
  );
}

function Field({ label, value, onChange, type = "text", testid }) {
  return (
    <div>
      <label className="block text-xs font-semibold text-neutral-400 mb-1.5">{label}</label>
      <input type={type} value={value} onChange={onChange} data-testid={testid} className="w-full bg-black border border-white/15 rounded-md px-4 py-3 text-sm text-white focus:border-alto-red outline-none" />
    </div>
  );
}
